import { SubmissionState } from './../../models/ApplicationState';
import { SubmissionDataActions, SubmissionDataActionTypes } from './submissionDataActions';
export const defaultSubmissionState: SubmissionState = {
    submissions: [],
    columnConfig:[],
    showViewFormDialog: false,
    showEditDialog: false,
    showDeleteDialog: false,
    submissionDataLoading: false,
    submissionDataLoadingFailure: false,
    submissionDataLoadingSuccess: false
};
export const submissionDataReducer = (state: SubmissionState = defaultSubmissionState,
    action: SubmissionDataActions): SubmissionState => {
    switch (action.type) {
        case SubmissionDataActionTypes.SUBMISSION_REQUEST:
            return {
                ...state,
                submissionDataLoading: true,
                submissionDataLoadingFailure: false,
                submissionDataLoadingSuccess: false
            };
        case SubmissionDataActionTypes.SUBMISSION_SUCCESS: {
            return {
                ...state,
                submissions: action.data,
                submissionDataLoading: false,
                submissionDataLoadingSuccess: true,
                submissionDataLoadingFailure: false,
            };
        }
        case SubmissionDataActionTypes.SUBMISSION_FAILURE:
            return {
                ...state,
                submissions:[],
                submissionDataLoading: false,
                submissionDataLoadingFailure: true,
                submissionDataLoadingSuccess: false
            };
        case SubmissionDataActionTypes.DELETE_SUBMISSION:
            return {
                ...state,
                submissionDataLoading: true,
                submissionDataLoadingFailure: false,
                submissionDataLoadingSuccess: false
            };
        case SubmissionDataActionTypes.DELETE_SUBMISSION_SUCCESS: {
            return {
                ...state,
                submissionDataLoading: false,
                submissionDataLoadingSuccess: true,
                submissionDataLoadingFailure: false,
            };
        }
        case SubmissionDataActionTypes.DELETE_SUBMISSION_SUCCESS: return {
            ...state,
            submissionDataLoading: false,
            submissionDataLoadingFailure: true,
            submissionDataLoadingSuccess: false
        };
        case SubmissionDataActionTypes.SHOW_VIEW_FORM_DIALOG: return {
            ...state,
            showViewFormDialog: true
        };
        case SubmissionDataActionTypes.SHOW_EDIT_FORM_DIALOG: return {
            ...state,
            showEditDialog: true
        };
        case SubmissionDataActionTypes.SHOW_DELETE_RECORD_DIALOG: return {
            ...state,
            showDeleteDialog: true
        };
        case SubmissionDataActionTypes.CLOSE_VIEW_FORM_DIALOG: return {
            ...state,
            showViewFormDialog: false
        };
        case SubmissionDataActionTypes.CLOSE_EDIT_FORM_DIALOG: return {
            ...state,
            showEditDialog: false
        };
        case SubmissionDataActionTypes.CLOSE_DELETE_RECORD_DIALOG: return {
            ...state,
            showDeleteDialog: false
        };
        case SubmissionDataActionTypes.GET_COLUMN_CONFIG:
            return {
                ...state,
                submissionDataLoading: true,
                submissionDataLoadingFailure: false,
                submissionDataLoadingSuccess: false
            };
        case SubmissionDataActionTypes.GET_COLUMN_SUCCESS: {
            return {
                ...state,
                columnConfig: action.data,
                submissionDataLoading: false,
                submissionDataLoadingSuccess: true,
                submissionDataLoadingFailure: false,
            };
        }
        case SubmissionDataActionTypes.GET_COLUMN_FAILURE:
            return {
                ...state,
                columnConfig: [],
                submissionDataLoading: false,
                submissionDataLoadingFailure: true,
                submissionDataLoadingSuccess: false
            };
        default:
            return state;
    }
};
